<div class="search-head">
  <div class="search-head__input">
      <i class="fa fa-search"></i>
      <input type="text" class="form-control" 
      placeholder="Palavra chave..."
      [(ngModel)]="searchParams.nome"
      (keyup.enter)="doSearchByName()">

      <div class="filter-button">
        <a href="javascript:;" class="btn btn-primary" 
          data-wizard-action="next" (click)="doSearch()">
              Procurar
            <i class="fa fa-chevron-right"></i>
        </a>
      </div>  
  </div>

  <div class="search-head__buttons">
    <div class="dropdown" *ngIf="shouldShowImport" [class.open]="isDropdownOpen">
      <a href="javascript:;" class="btn btn-outline-primary" (click)="toggleDropdown($event)">
        <i class="fa fa-file-import"></i> {{ importExcelTitle }}
      </a>
      <div class="dropdown-content">
        <a *ngFor="let attr of importExcelAttr.attributes" 
          href="javascript:;" 
          (click)="handleDropdownOption(attr)">
            {{ attr.value }}
        </a>
      </div>
    </div>

    <a *ngIf="shouldShowExport" href="javascript:;"
      class="btn btn-outline-primary"
      id="btnGerarExcel"
      (click)="doExport()">
      <i class="fa fa-file-excel"></i> {{ exportExcelTitle }}
    </a>

    <a *ngFor="let link of createLinks" 
      href="javascript:;" 
      class="btn btn-outline-primary" 
      (click)="createNewRecord(link)">
      <i class="fa fa-plus"></i> {{ link.value }}
    </a>
  </div>

  <input type="file" #fileInput accept=".xls, .xlsx" (change)="onFileSelected($event)" style="display: none;" />
</div>

<div *ngIf="filters.length > 0" class="search-head__filter">
    <button (click)="toggleAdvancedSearch()">
        Busca Avançada
    </button>
</div>

<div class="search-advanced" [ngClass]="{ 'hidden': !showAdvancedSearch }">
  <div class="row">
    <app-dynamic *ngFor="let item of filters" 
      [class]="getSizeClass(item)" 
      [attribute]="item"
      (onEmit)="handle($event)">
    </app-dynamic>
  </div>
</div>
